export default "__VITE_ASSET__DbvaNkp1__";